declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_localized_in_object_foo extends $mol_object {
		outer( next?: string ): string
		obj( ): ({ 
			loc( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_localized_in_object_foo['outer'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_localized_in_object_foo['outer'] >,
		}) 
	}
	
}

//# sourceMappingURL=bidi_localized_in_object.view.tree.d.ts.map